import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { TResultTanquerayProps } from "../type";
import { DdpImage } from "@/components/shared/DdpImage";
import { DdpCta } from "@/components/shared/DdpCta";
import { useEffect, useState } from "react";
import { getCocktailInfo, interaction } from "@/shared/utils";
import { TCocktail } from "@/shared/types";

export function BigCard(props: TResultTanquerayProps) {
    const {
        textBestMatchDreamerCocktail,
        dreamerCocktailPreview,
        ctaLearnMoreDreamerCocktail
    } = props
    const { secondResults, results } = useAppStore()!
    const matchBestId = secondResults?.cocktailRecommendations[0].cocktailId
    const [cocktailInfo, setCocktailInfo] = useState<TCocktail>()
    useEffect(() => {
        if (!secondResults || !matchBestId) return
        getCocktailInfo([matchBestId], 'secondCocktailList').then((cocktail) => {
            setCocktailInfo(cocktail[0])
        })
    }, [secondResults])
    //已经排序过了 第一个是最匹配的

    // const cocktailInfo = cocktailList.find((item) => item.cocktailID.id === dreamerCocktailPreview[0].iDDreamerCocktail)
    // const cocktailInfo = finalCocktailList.find((item) => item.id === matchBestId)!
    const dreamerCocktailPreviewItem = dreamerCocktailPreview.find((item) => item.iDDreamerCocktail === matchBestId)!
    const { locale, storeConfig } = useCmsStore()!
    return (
        <div className='big-card-container'>
            <div className="cocktai-media-wrapper" >
                {/* <SingleImg image={cocktailInfo.recipeFirstImage} /> */}
                <DdpImage image={dreamerCocktailPreviewItem.topImage[0]} />
            </div>
            <div className="cocktail-content-wrapper" >
                <div className="big-wrapper">
                    <div className="best-match">{textBestMatchDreamerCocktail}</div>
                    <div className="temp-warpper">
                        <div className="title">{dreamerCocktailPreviewItem.previewTitle}</div>
                        <div className="desc" dangerouslySetInnerHTML={{ __html: cocktailInfo?.cocktailDescription || '' }}></div>
                    </div>
                    <DdpCta className="cta-learn-more" cta={{
                        show: ctaLearnMoreDreamerCocktail[0].show,
                        text: ctaLearnMoreDreamerCocktail[0].text,
                        url: ctaLearnMoreDreamerCocktail[0].url + '?cocktailId=' + dreamerCocktailPreviewItem.iDDreamerCocktail
                    }}
                        onClick={() => {
                            interaction([dreamerCocktailPreviewItem.iDDreamerCocktail], `${locale}_${storeConfig.secondSitename?.id}`, results?.consumerId as string, 'Click')
                        }}
                    />
                </div>
            </div>
        </div>
    )
}